import styled from 'styled-components';

import { hexToRGBA } from '@xemplo/color-util';
import {
  BodySmallRegular,
  BodyStandardMedium,
  Colour,
  HeadingStandardMedium,
  MinBreakpointV2,
  TextEllipsis,
} from '@xemplo/style-constants';

export const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  box-sizing: border-box;
  display: flex;

  gap: 24px;
  align-items: center;
  transition: box-shadow 0.2s ease-out;
  padding: 24px 16px 20px 16px;

  .header-btn {
    margin-left: auto;
    margin-right: 36px;
    @media ${MinBreakpointV2.medium} {
      margin-right: 0;
    }
  }

  .header-icon-container {
    display: none;
  }

  @media ${MinBreakpointV2.medium} {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 44px 40px 32px 40px;
    .header-icon-container {
      display: block;
    }
  }

  &.showKeyline {
    border-bottom: 1px solid ${Colour.Clarity.Grey.Soft};
  }
  &.showShadow {
    box-shadow: 0px 4px 8px ${hexToRGBA(Colour.Clarity.Grey.Soft, 0.4)};
  }
`;

export const HeaderTitle = styled.span`
  ${TextEllipsis};
  ${BodyStandardMedium};
  white-space: initial;
  color: ${Colour.Clarity.Content.Hard};
  display: flex;
  gap: 4px;
  flex-direction: column;
  @media ${MinBreakpointV2.medium} {
    ${HeadingStandardMedium};
  }
  .description {
    ${BodySmallRegular};
    color: ${Colour.Clarity.Content.Soft};
  }
`;
